import _ from 'lodash'
import BaseRender from './base.vue'
import { addI18nProperty } from '@/i18n'

export default {
  components: {
    BaseRender
  },
  props: {
    fieldTypeInfo: {
      required: true
    },
    fieldInfo: {
      required: true
    }
  },
  data () {
    return {
      loading: false,
      i18nPrefix: 'admin.company.jobPosting'
    }
  },
  computed: {
    channelName () {
      return this.fieldTypeInfo.channel?.i18nName
    },
    fieldTypeName () {
      return this.fieldTypeInfo.i18nName
    }
  },
  methods: {
    formatRef (ref) {
      if (Array.isArray(ref)) {
        return ref[0]
      }
      return ref
    },
    exchangeFieldOption (optionsList) {
      const result = []
      const maxDepth = optionsList.length - 1
      const groupTemp = []
      const exchange = (depth) => {
        _.forEach(optionsList[depth], (item) => {
          groupTemp[depth] = item
          if (depth === maxDepth) {
            result.push(groupTemp.concat())
          } else {
            exchange(depth + 1)
          }
        })
      }
      exchange(0)
      return result
    },
    setError (refNames, noNextTick) {
      if (!refNames || refNames.length < 1) {
        return
      }
      const firstRefName = refNames[0]
      const firstRef = this.formatRef(this.$refs[firstRefName])
      if (!firstRef) {
        if (noNextTick) {
          throw new Error(`can not found ref with name: ${firstRefName}`)
        } else {
          this.$nextTick(() => {
            this.setError(refNames, true)
          })
        }
        return
      }
      _.forEach(refNames, name => {
        const ref = this.formatRef(this.$refs[name])
        const el = ref.$el || ref
        el.classList.add('has-error')
      })
      const firstEl = firstRef.$el || firstRef
      firstEl.scrollIntoView({ block: 'center', behavior: 'smooth' })
      if (firstRefName === 'defaultValue') {
        this.$message.error(this.$t('admin.company.jobPosting.message.defaultIsRequired'))
      } else {
        this.$message.error(this.$t('admin.company.jobPosting.message.mappingHasEmpty'))
      }
    },
    clearError (refName, noNextTick) {
      const ref = this.$refs[refName]
      if (!ref) {
        if (noNextTick) {
          throw new Error(`can not found ref with name: ${refName}`)
        } else {
          this.$nextTick(() => {
            this.clearError(refName, true)
          })
        }
        return
      }
      const el = ref.$el || ref
      el.classList.remove('has-error')
    },
    formatCompanyData (mappingList, originDataMap, companyTree, children) {
      _.forEach(children, item => {
        addI18nProperty(item, 'i18nName', 'cn_name', 'name')
        const dataMap = originDataMap[`${item.id}`] || { key: `${item.id}`, value: null }
        mappingList.push({
          id: mappingList.length + 1,
          self: item,
          other: dataMap
        })
        const itemChildren = companyTree[item.id]
        if (itemChildren && itemChildren.length > 0) {
          this.formatCompanyData(mappingList, originDataMap, companyTree, itemChildren)
        }
      })
    }
  }
}
